import { createAction } from 'redux-act';

export const getPreference = createAction('get all user preference');
export const updateGridPreference = createAction('update grid preference');
export const insertGridPreference = createAction('insert grid preference');
export const setUserPreference = createAction('Set the user preference to the store');
export const setUpdatedGridPreference = createAction('Set the updated user preference to the store');
